import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'Components/UI/_Legacy'

import { TitleText } from './styles'

function HeadingTitle({
  horizontalAlign = 'center',
  titleText,
  fontSize,
  light = false,
  as = 'h2',
}) {
  return (
    <Text as={as} fontSize={fontSize} textAlign={horizontalAlign}>
      <TitleText bold={titleText?.first?.bold} light={light}>
        {titleText?.first?.text}
        &nbsp;
      </TitleText>

      <TitleText bold={titleText?.second?.bold} light={light}>
        {titleText?.second?.text}
        &nbsp;
      </TitleText>

      <TitleText bold={titleText?.third?.bold} light={light}>
        {titleText?.third?.text}
      </TitleText>
    </Text>
  )
}

HeadingTitle.propTypes = {
  as: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.array]).isRequired,
  horizontalAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  light: PropTypes.bool,
  titleText: PropTypes.object.isRequired,
}

export default HeadingTitle
